import { FieldArray, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { Input } from "../../components/ui/input";
import SearchSelect from "../../components/SearchSelect";
import SuburbSelect from "../../components/SuburbSelect";
import PostalCodeInput from "../../components/PostalCodeInput";
import ReactInputMask from "react-input-mask";
import { cn } from "../../lib/utils";
import { Button } from "../../components/ui/button";
import { useAllOrganizationTypes, useStateList } from "../Auth/SignUpHelper";
import { SuburbList, useRoleList, useUserList } from "../../lib/OptionsAPI";
import { Loader2, Plus, Trash2 } from "lucide-react";
import { API, fileUpload, get } from "../../config";
import { AddOrganizationSchema } from "../../lib/Validation";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { CardTitle } from "../../components/ui/card";
import ProfileUpload from "../../components/ProfileUpload";
import { Checkbox } from "../../components/ui/checkbox";
// import UserSelect from "../../components/UserSelect";
// import { formatSubcontractorName } from "../../lib/Misc";

const AddOrganizations = ({
  toggleAddOrganizationModal,
  orgId,
  edit,
  tab = false,
}) => {
  const [loading, setLoading] = React.useState(false);

  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);

  // const [userLoading, setUserLoading] = useState(false);
  // const [userListing, setUserListing] = useState([]);
  // const [userList, setUserList] = useState([]);

  const [organizationData, setOrganizationData] = useState();

  async function fetchData() {
    try {
      setLoading(true);
      const { data } = await get(`${API.ORGANIZATION_DETAILS}/${orgId}`);
      if (data?.data?.state_id ? data?.data?.state_id : false) {
        FetchSuburbList(data?.data?.state_id ? data?.data?.state_id : "", "");
        if (data?.data?.suburb_id ? data?.data?.suburb_id : false) {
          setSuburbList([
            data?.data?.suburb
              ? {
                  ...data?.data?.suburb,
                  value: data?.data?.suburb.id,
                  label: data?.data?.suburb.name,
                }
              : {},
          ]);
        }
      }
      setOrganizationData(data?.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setOrganizationData(null);
    }
  }
  useEffect(() => {
    if (edit && orgId) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  // eslint-disable-next-line no-unused-vars
  const { stateLoading, stateList = [] } = useStateList();
  const stateArray = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });

  const { allOrganizationTypeLoading, allOrganizationType = [] } =
    useAllOrganizationTypes({ amlCTFType: false });
  const organizationType = allOrganizationType?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name, value, ...rest };
  });

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  const {
    updateOrganizationData,
    updateOrganizationList,
    updateOrganizationId,
    organizationData: organizationDataContext,
  } = useOrganization();

  // Role
  const { roleLoading, roleList = [] } = useRoleList();
  const roleListing = roleList ? roleList : [];

  // User
  const { userLoading, userList = [] } = useUserList(orgId);
  const userListing = userList ? userList : [];

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  // useEffect(() => {
  //   if (userList) {
  //     let userTempListing = userList?.map((item) => ({
  //       ...item,
  //       value: item?.id,
  //       label: formatSubcontractorName(item),
  //     }));
  //     setUserListing(userTempListing || []);
  //   } else {
  //     setUserListing([]);
  //   }
  // }, [userList]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";

    let state_id = value?.state_id ? value?.state_id : "";
    let suburb_id = value?.suburb_id ? value?.suburb_id : "";

    value?.logo && formData.append("logo", value?.logo ? value?.logo : "");

    formData.append("abn", value?.abn ? value?.abn : "");
    formData.append(
      "license_number",
      value?.license_number ? value?.license_number : ""
    );
    formData.append("organization_type_id", value?.type);
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : ""
    );
    formData.append(
      "business_email",
      value?.business_email ? value?.business_email : ""
    );
    formData.append("is_invoicing", value?.is_invoicing ? 1 : 0);
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", state_id ? state_id : "");
    formData.append("suburb_id", suburb_id ? suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );

    for (let i = 0; i < value?.users?.length; i++) {
      formData.append(`users[${i}][user_id]`, value?.users[i]?.user_id);
      formData.append(`users[${i}][role_id]`, value?.users[i]?.role_id);
    }

    if (orgId) {
      formData.append("_method", "put");
    }

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.ORGANIZATION_ADD}${orgId ? `/${orgId}` : ""}`,
        formData
      );
      setLoading(false);
      if (data?.status === 200 && data?.message) {
        toggleAddOrganizationModal && toggleAddOrganizationModal();
        if (edit) {
          let currentList = organizationDataContext?.organizationList;
          const updatedArr = currentList.map((obj) => {
            let label = obj?.label
              ? obj?.label
              : obj?.business_name
              ? obj?.business_name
              : "";
            if (obj.value === orgId) {
              label = data?.data?.business_name
                ? data?.data?.business_name
                : "";
              return { ...data?.data, label, value: orgId };
            }

            return { ...obj, label };
          });
          await updateOrganizationList(updatedArr);
          await updateOrganizationData(data?.data);
          await updateOrganizationId(orgId);
        } else {
          updateOrganizationList(
            data?.data?.map((item) => {
              return {
                ...item,
                value: item?.id ? item?.id : "",
                label: item?.business_name ? item?.business_name : "",
              };
            })
          );
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        business_name:
          edit && organizationData?.business_name
            ? organizationData?.business_name
            : "",
        business_email:
          edit && organizationData?.email ? organizationData?.email : "",
        type:
          edit && organizationData?.organization_type_id
            ? organizationData?.organization_type_id
            : "",
        logo: edit && organizationData?.logo ? organizationData?.logo : "",
        abn: edit && organizationData?.abn ? organizationData?.abn : "",
        license_number:
          edit && organizationData?.license_number
            ? organizationData?.license_number
            : "",
        is_invoicing: edit && organizationData?.is_invoicing ? true : false,
        street:
          edit && organizationData?.street ? organizationData?.street : "",
        state_id:
          edit && organizationData?.state_id ? organizationData?.state_id : "",
        suburb_id:
          edit && organizationData?.suburb_id
            ? organizationData?.suburb_id
            : "",
        postal_code:
          edit && organizationData?.postal_code
            ? organizationData?.postal_code
            : "",
        users:
          edit && organizationData?.users?.length > 0
            ? organizationData?.users
            : [{ user_id: "", role_id: "" }],
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={false}
      validationSchema={AddOrganizationSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div
              className={`form-box overflow-hidden overflow-y-auto ${
                edit ? "max-h-[68vh]" : "max-h-[80vh]"
              } p-4 border rounded-lg ${
                edit ? "!p-0 border-none rounded-none" : ""
              }`}
            >
              <div>
                <ProfileUpload
                  path={values?.logo}
                  pathData={values?.business_name?.charAt(0)}
                  setFieldValue={setFieldValue}
                  keyName={"logo"}
                  popupType={tab ? "organizations" : ""}
                />
              </div>
              <div className="grid gap-4 mt-5">
                <CardTitle>Entity Details</CardTitle>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="business_name">
                      <CustomLabelText
                        required={true}
                        labelText="Business Name"
                        errorField={errors?.business_name}
                      />
                    </Label>
                    <Input
                      id="business_name"
                      placeholder="Enter Business Name"
                      name="business_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.business_name}
                      className={
                        errors?.business_name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="business_email">
                      <CustomLabelText
                        required={true}
                        labelText="Business Email"
                        errorField={errors?.business_email}
                      />
                    </Label>
                    <Input
                      id="business_email"
                      type="email"
                      placeholder="m@example.com"
                      autoComplete="off"
                      name="business_email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.business_email}
                      className={
                        errors?.business_email &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="street">
                      <CustomLabelText
                        required={true}
                        labelText="Street Address"
                        errorField={errors?.street}
                      />
                    </Label>
                    <Input
                      id="street"
                      placeholder="Enter Street"
                      name="street"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.street}
                      className={
                        errors?.street &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="state_id">
                      <CustomLabelText
                        required={true}
                        labelText="State"
                        errorField={errors?.state_id}
                      />
                    </Label>
                    <SearchSelect
                      frameworks={stateArray}
                      optionType={"State"}
                      clearable={true}
                      onClear={() => {
                        setFieldValue("state_id", "");
                        setFieldValue("suburb_id", "");
                        setSuburbList([]);
                      }}
                      handleSelect={(e) => {
                        setFieldValue("state_id", e);
                        setFieldValue("suburb_id", "");
                        setSuburbList([]);
                        FetchSuburbList(e);
                      }}
                      handleBlur={handleBlur}
                      initialValue={values?.state_id}
                      className={
                        errors?.state_id &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                      disabled={false}
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="suburb_id">
                      <CustomLabelText
                        required={true}
                        labelText="Suburb"
                        errorField={errors?.suburb_id}
                      />
                    </Label>
                    <div className="relative">
                      <SuburbSelect
                        state_id={values?.state_id} // Pass the selected state ID
                        frameworkData={suburbListing} // List of suburbs
                        loading={suburbLoading}
                        onClear={() => {
                          setFieldValue("suburb_id", "");
                        }}
                        optionType="Suburb"
                        handleSelect={(e) => {
                          setFieldValue("suburb_id", e);
                        }}
                        name="suburb_id"
                        handleBlur={handleBlur}
                        className={
                          errors?.suburb_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={values?.state_id ? false : true}
                        initialValue={values?.suburb_id}
                        setSuburbList={setSuburbList} // Update suburb list as new data loads
                        setSuburbLoading={setSuburbLoading} // Control loading state
                      />
                      {suburbLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="postal_code">
                      <CustomLabelText
                        required={true}
                        labelText="Postal Code"
                        errorField={errors?.postal_code}
                      />
                    </Label>
                    <PostalCodeInput
                      id="postal_code"
                      placeholder="Enter Postal Code"
                      required={true}
                      name="postal_code"
                      handleChange={(e) => {
                        setFieldValue("postal_code", e);
                      }}
                      handleBlur={handleBlur}
                      className="justify-start"
                      inputClassName={
                        errors?.postal_code &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                      value={values?.postal_code ? values?.postal_code : ""}
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="type">
                      <CustomLabelText
                        required={true}
                        labelText="Industry Type"
                        errorField={errors?.type}
                      />
                    </Label>
                    <div className="relative">
                      <SearchSelect
                        frameworks={organizationType}
                        optionType={"Industry Type"}
                        handleSelect={(e) => {
                          let is_auctioner = organizationType?.find(
                            (item) =>
                              item.value === e &&
                              item.rest.slug === "auctioneer"
                          );
                          if (is_auctioner) {
                            setFieldValue("is_invoicing", true);
                          } else {
                            setFieldValue("is_invoicing", false);
                          }
                          setFieldValue("type", e);
                        }}
                        handleBlur={handleBlur}
                        className={
                          errors?.type &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        initialValue={values?.type}
                        disabled={false}
                      />
                      {allOrganizationTypeLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="abn">
                      <CustomLabelText
                        required={false}
                        labelText="ABN"
                        errorField={errors?.abn}
                      />
                    </Label>
                    <ReactInputMask
                      id="abn"
                      type="text"
                      name="abn"
                      value={values?.abn ? values?.abn : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      mask="99 999 999 999"
                      maskChar={null}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.abn
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="license_number">
                      <CustomLabelText
                        labelText="Unique ID/REBA/Licence No."
                        errorField={errors?.license_number}
                      />
                    </Label>
                    <Input
                      id="license_number"
                      placeholder="Enter Licence Number"
                      required
                      name="license_number"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.license_number}
                      className={
                        errors?.license_number &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  {organizationType?.find(
                    (item) =>
                      item.value === values?.type &&
                      item.rest.slug === "auctioneer"
                  ) ? (
                    <div className="flex items-center space-x-2 mt-4">
                      <Checkbox
                        id="is_invoicing"
                        checked={values?.is_invoicing}
                        name="is_invoicing"
                        onClick={() => {
                          setFieldValue("is_invoicing", !values?.is_invoicing);
                        }}
                      />
                      <label
                        htmlFor="is_invoicing"
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                      >
                        Invoicing (Only For Bank Reconciliation)
                      </label>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {edit && (
                <div className="grid gap-4 pt-4">
                  <CardTitle>User & Role</CardTitle>
                  <FieldArray
                    name="users"
                    render={(arrayHelpers) => (
                      <>
                        {values.users.map((user, index) => (
                          <div key={index}>
                            <div className="grid grid-cols-4 gap-4">
                              <div className="grid gap-2">
                                <Label htmlFor="user">
                                  <CustomLabelText
                                    required={false}
                                    labelText="User"
                                    errorField={errors?.users?.[index]?.user_id}
                                  />
                                </Label>
                                <div className="relative">
                                  {/* <UserSelect
                                    orgId={orgId}
                                    frameworkData={userListing} // List of vendors
                                    optionType="User"
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `users.${index}.user_id`,
                                        e
                                      );
                                      let userData = userListing?.find(
                                        (item) => item.value === e
                                      );
                                      if (userData?.role_id) {
                                        setFieldValue(
                                          `users.${index}.role_id`,
                                          userData?.role_id
                                        );
                                      }
                                    }}
                                    name="user_id"
                                    disabled={false}
                                    initialValue={
                                      values?.users?.[index]?.user_id
                                        ? values?.users?.[index]?.user_id
                                        : ""
                                    }
                                    setUserList={setUserList} // Update vendor list as new data loads
                                    setUserLoading={setUserLoading} // Control loading state
                                    onClear={() => {
                                      setFieldValue(
                                        `users.${index}.user_id`,
                                        ""
                                      );
                                      setFieldValue(
                                        `users.${index}.role_id`,
                                        ""
                                      );
                                    }}
                                    className={
                                      errors?.users?.[index]?.user_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    loading={userLoading}
                                  /> */}
                                  <SearchSelect
                                    frameworks={userListing}
                                    optionType={"User"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `users.${index}.user_id`,
                                        e
                                      );
                                      let userData = userListing?.find(
                                        (item) => item.value === e
                                      );
                                      if (userData?.role_id) {
                                        setFieldValue(
                                          `users.${index}.role_id`,
                                          userData?.role_id
                                        );
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.users?.[index]?.user_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    clearable={false}
                                    disabled={false}
                                    initialValue={
                                      values?.users?.[index]?.user_id
                                        ? values?.users?.[index]?.user_id
                                        : ""
                                    }
                                    onClear={() => {
                                      setFieldValue(
                                        `users.${index}.user_id`,
                                        ""
                                      );
                                      setFieldValue(
                                        `users.${index}.role_id`,
                                        ""
                                      );
                                    }}
                                  />
                                  {userLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>

                              <div className="grid gap-2">
                                <Label htmlFor="role_id">
                                  <CustomLabelText
                                    required={false}
                                    labelText="Role"
                                    errorField={errors?.users?.[index]?.role_id}
                                  />
                                </Label>

                                <div className="relative">
                                  <SearchSelect
                                    frameworks={roleListing}
                                    optionType={"Role"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `users.${index}.role_id`,
                                        e
                                      );
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.users?.[index]?.role_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    clearable={false}
                                    disabled={true}
                                    initialValue={
                                      values?.users?.[index]?.role_id
                                        ? values?.users?.[index]?.role_id
                                        : ""
                                    }
                                  />
                                  {roleLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="flex gap-2 items-center mt-4">
                                {index + 1 === values?.users?.length ? (
                                  <>
                                    <Button
                                      type="button"
                                      className="h-fit w-fit p-1 "
                                      onClick={() =>
                                        arrayHelpers.push({
                                          tempId: index + 2,
                                          contract_file: "",
                                          contract_value: "",
                                          retention_percentage: "",
                                          retention_amount: "",
                                        })
                                      }
                                    >
                                      <Plus size={20} />
                                    </Button>{" "}
                                    {index > 0 && (
                                      <>
                                        {/* &nbsp;/&nbsp; */}
                                        <Button
                                          type="button"
                                          className="h-fit w-fit p-1 bg-red-500"
                                          onClick={() =>
                                            arrayHelpers.remove(index)
                                          }
                                        >
                                          <Trash2 size={20} />
                                        </Button>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      type="button"
                                      className="h-fit w-fit p-1 bg-red-500"
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <Trash2 size={20} />
                                    </Button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  />
                </div>
              )}
            </div>
            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              {toggleAddOrganizationModal && (
                <Button
                  className="reset ml-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleAddOrganizationModal();
                  }}
                  variant="secondary"
                >
                  Cancel
                </Button>
              )}
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddOrganizations;
